import React from 'react';
import styles from './Button.module.css';
import Icon from '../Icon/Icon';

/**
 * @component Button
 * @description 범용 버튼 컴포넌트
 */
function Button({
  children,
  variant = 'primary',
  size = 'medium',
  icon,
  iconPosition = 'left',
  sparkle = false,
  onClick,
  disabled = false,
  fullWidth = false,
  type = 'button',
  className = '',
}) {
  const buttonClasses = [
    styles.button,
    styles[variant],
    styles[size],
    fullWidth && styles.fullWidth,
    disabled && styles.disabled,
    className,
  ]
    .filter(Boolean)
    .join(' ');

  return (
    <button
      type={type}
      className={buttonClasses}
      onClick={onClick}
      disabled={disabled}
    >
      {icon && iconPosition === 'left' && (
        <Icon name={icon} size="20" className={styles.icon} />
      )}
      <span className={styles.label}>{children}</span>
      {icon && iconPosition === 'right' && (
        <Icon name={icon} size="20" className={`${styles.icon}${sparkle ? ` ${styles.sparkleIcon}` : ''}`} />
      )}
    </button>
  );
}

export default Button;
